'use strict';

/**
 *  Load modules
 */
import "core-js/stable";
import "regenerator-runtime/runtime";
import menu from './modules/menu.js';
import servicesSlider from './modules/services-slider.js';
import stickySidebar from './modules/sticky-sidebar.js';
import faq from "./modules/faq.js";

import '../scss/app.scss';

$(document).ready(() => {
    

    AOS.init();

    menu();
    servicesSlider();
    stickySidebar();
    faq();


    const scrollTopBtn = document.querySelector('.scroll-top');
    const scrollTopLogo = document.querySelectorAll('.to-top');

    if (scrollTopLogo) {   
        scrollTopLogo.forEach(item => {
            item.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        });
    }

    if (scrollTopBtn) {

        scrollTopBtn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });


        window.addEventListener('scroll', () => {
            if (window.scrollY > 300) {
                scrollTopBtn.classList.add('visible');
            } else {
                scrollTopBtn.classList.remove('visible');
            }
        });

    }

    // const menuItems = document.querySelectorAll('.menu-item');
    // const links = document.querySelectorAll('.menu-item a');
    // const sections = document.querySelectorAll('section');

    // const getHeaderHeight = () => {
    //     const header = document.querySelector('.header');
    //     return header ? header.offsetHeight : 0;
    // };


    // links.forEach(link => {
    //     link.addEventListener('click', function (e) {
    //         const href = this.getAttribute('href');

    //         if (!href.startsWith('#')) return;

    //         e.preventDefault();

    //         const target = document.querySelector(href);
    //         if (!target) return;

    //         const offset = target.offsetTop - getHeaderHeight();

    //         window.scrollTo({
    //             top: offset,
    //             behavior: 'smooth'
    //         });

    //         menuItems.forEach(item => item.classList.remove('active'));
    //         this.closest('.menu-item').classList.add('active');
    //     });
    // });

document.querySelectorAll('a[href^="#"]').forEach(link => {

    link.addEventListener('click', function(e) {

        const id = this.getAttribute('href');

        const section = document.querySelector(id);

        if (!section) return;

        e.preventDefault();


        const offset = 50;

        const position = section.getBoundingClientRect().top + window.scrollY + offset;


        window.scrollTo({
            top: position,
            behavior: 'smooth'
        });

    });

});
    


    // window.addEventListener('scroll', () => {
    //     let current = '';

    //     sections.forEach(section => {
    //         const top = section.offsetTop - getHeaderHeight() - 50;
    //         const height = section.offsetHeight;

    //         if (window.scrollY >= top && window.scrollY < top + height) {
    //             current = section.getAttribute('id');
    //         }
    //     });

    //     menuItems.forEach(item => {
    //         item.classList.remove('active');

    //         const link = item.querySelector('a');
    //         if (!link) return;

    //         if (link.getAttribute('href') === '#' + current) {
    //             item.classList.add('active');
    //         }
    //     });
    // });

});
